var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-cascader", {
        attrs: {
          value: _vm.value,
          options: _vm.options,
          props: _vm.props,
          placeholder: _vm.placeholder,
          clearable: "",
        },
        on: { change: _vm.changeHandle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }